import { UserMembership } from 'components/loyalty-program/user-membership/UserMembership'
import { useLocation, useSearchParams } from 'react-router-dom'
import {
    convertErrorMessage,
    downloadFile,
    getAllQueryParams,
    getObjectName,
    getQueryFilter,
    setQueryParams,
} from 'utils/utils'
import { INITIAL_DATA_FILTER, INIT_FILTER } from 'configs/loyalty-program/configTableUserMembership'
import { useEffect, useState } from 'react'
import { Alert } from 'avo-ui'
import { useValidation } from 'hooks/useValidation'
import { ACTION_TYPE } from 'constants/constant'
import { USER_MEMBERSHIP_VALIDATION } from 'services/validation/userMembershipValidation'
import { useFetch } from 'services/useFetch'
import { API_USER_MEMBERSHIP } from 'services/apiUserMembership'
import moment from 'moment'

const INIT_STATE = {
    name: null,
    email: null,
    phone_number: null,
    total_point: null,
}

const FIELD_NAME_DETAIL = {
    name: 'Nama',
    email: 'Email',
    phone_number: 'No. Telepon',
}

export const UserMembershipContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [queryFilter, setQueryFilter] = useState({})
    const [selectedIds, setSelectedIds] = useState([])
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const [userMembershipDetail, setUserMembershipDetail] = useState({})
    const [errorMessage, setErrorMessage] = useState({})
    const { fetching: getUserMembership, data: userMembership, isLoading } = useFetch(API_USER_MEMBERSHIP.LIST)
    const { fetching: createUserMembership, isCreating } = useFetch(API_USER_MEMBERSHIP.CREATE)
    const { fetching: deleteUserMembership, isDeleting } = useFetch(API_USER_MEMBERSHIP.DELETE)
    const { fetching: exportUserMembership, isExporting } = useFetch(API_USER_MEMBERSHIP.EXPORT)
    const { validateForm, errorForm, clearErrorForm } = useValidation({
        form: userMembershipDetail,
        schema: USER_MEMBERSHIP_VALIDATION,
    })
    const [modal, setModal] = useState({
        filter: false,
        delete: false,
        export: false,
        form: false,
    })

    useEffect(() => {
        const currentQuery = { ...query }
        const newQueryFilter = { ...INIT_FILTER }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (key === 'types') {
                const valueOfQuery = item?.split(',')
                newQueryFilter[key] = valueOfQuery
                currentQuery[key] = valueOfQuery
            }
        })
        setQueryFilter(newQueryFilter)
        fetchUserMembershipList(currentQuery)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) => ['search', 'start_date', 'type'].includes(item))
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchUserMembershipList = (item = { ...query, ...queryFilter }) => {
        getUserMembership(item)
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onHideForm = () => {
        setShowModal({ form: false })
        setErrorMessage({})
        clearErrorForm()
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const onActionRow = (type) => {
        if (type === ACTION_TYPE?.CREATE) {
            setUserMembershipDetail(INIT_STATE)
            setShowModal({ form: true })
        } else {
            setShowModal({ delete: true })
        }
    }

    const onSelectSort = (value) => {
        const splitSort = value?.split('-')
        onChangeQuery({ order_by: splitSort[0], order_type: splitSort[1] })
    }

    const onFilter = (filter) => {
        const queryFilter = getQueryFilter(filter)
        onChangeQuery({ ...queryFilter, page: 1 })
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setUserMembershipDetail({ ...userMembershipDetail, [name]: value })
    }

    const onDelete = () => {
        deleteUserMembership({ ids: selectedIds }).then(() => {
            setIsResetSelectedItem(!isResetSelectedItem)
            setShowAlert('User Membership Deleted !', { delete: false })
            if (userMembership?.data?.rows?.length === 1 && Number(query?.page) !== 1) {
                onChangeQuery({ page: 1 })
            } else {
                fetchUserMembershipList()
            }
        })
    }

    const onExport = () => {
        const combineObj = { ...query, ...queryFilter }
        const { page, limit, ...dataFilterRest } = combineObj
        const payload = { ...dataFilterRest, ids: selectedIds }
        exportUserMembership(payload, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `User-Membership-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setShowAlert('User Membership Exported', { export: false })
        })
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            const payload = {
                ...userMembershipDetail,
                phone_number: `62${userMembershipDetail?.phone_number}`,
            }
            createUserMembership(payload)
                .then(() => {
                    setShowAlert('User Membership Created !', { form: false })
                    fetchUserMembershipList()
                })
                .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
        })
    }

    const props = {
        dataList: userMembership?.data,
        modal,
        setShowModal,
        query,
        queryFilter,
        onChangeQuery,
        onSelectSort,
        onFilter,
        selectedIds,
        onExport,
        onDelete,
        onSelectItemHandler,
        onActionRow,
        onChangeForm,
        onSubmit,
        onHideForm,
        errorForm: { ...errorForm, ...errorMessage },
        isResetSelectedItem,
        userMembershipDetail,
        isLoading,
        isExporting,
        isDeleting,
        isCreating,
    }

    return <UserMembership {...props} />
}
